import React, { ReactNode } from 'react';
import { ReactComponent as CircleCheckArea } from 'assets/circle-check-icon.svg';
import './SMSCheckArea.pcss';

type Props = {
  children: string | ReactNode | Element[];
};

export const SMSCheckArea = (props: Props) => {
  const { children } = props;

  return (
    <div className="sms-check-area">
      <CircleCheckArea className="sms-check-area__circle-check-icon" />

      <div className="sms-check-area__text-area">{children}</div>
    </div>
  );
};
